import React from 'react';
import Logo from '../../shared/components/dashboard/Logo';
import DownloadLogoSrc from '../../assets/images/logos/logo_download.svg';
import ActivityReport from './containers/activity-report/ActivityReport';
import DynamicTab from '../../shared/components/tabs/DynamicTab';
import { selectIsMsi } from '../../user-management/appSelectors';
import { useAppSelector } from '../../core/rootHooks';
import PortCalls from './containers/port-calls/PortCalls';
import StoppageEvents from './containers/stoppage-events/StoppageEvents';
import Voyages from './containers/voyages/Voyages';
import DailyAisSignals from './containers/daily-ais-signals/DailyAisSignals';

const Download: React.FC = () => {
	const isMsi = useAppSelector(selectIsMsi);

	const tabs = [
		{
			id: 'activity-report',
			label: 'Activity Report',
			content: <ActivityReport />,
		},
		{
			id: 'stoppage-events',
			label: 'Stoppage Events',
			content: <StoppageEvents />,
		},
		{
			id: 'port-calls',
			label: 'Port Calls',
			content: <PortCalls />,
		},
		{
			id: 'voyages',
			label: 'Voyages',
			content: <Voyages />,
		},	
		{
			id: 'daily-ais-signals',
			label: 'Daily AIS Signals',
			content: <DailyAisSignals />,
		},	
	];

	if (!isMsi) {
		return (
			<div className="flex items-center justify-center h-full">
				<p className="text-lg text-gray-500">
					This feature is not available for your account type. Please contact support for more information.
				</p>
			</div>
		);
	}

	return (
		<>
			<Logo src={DownloadLogoSrc} />
			<div className="flex-auto h-full w-full">
				<DynamicTab items={tabs} tabColor="msi-download-color" paddingClass="pl-40" />
			</div>
		</>
	);
};

export default Download;
